class Groups {
    static path = 'variables/groups';
    static vueMethods = {
        'triggerGroupPicker': ({bucket1, node}) => {
            window.VueApp.$modal.show('litegraph-item-picker');
        },
        'saveGroupPicker': ({item, node}) => {
            let data = item.split(' - ');
            let groupId = data[0];
            node.properties.value = item.slice(groupId.length + 3);
            node.properties.groupID = parseInt(groupId)
            window.VueApp.$modal.hide('litegraph-item-picker');
        }
    }

    constructor(mutator) {
        this.addOutput("value", "group,model");
        // this.widgets_up = true;
        this.bgcolor = '#fd754b';
        this.title = 'Xerocraft Group';
        this.desc = 'Select a group';
        this.properties = {value: '', groupID: 0, modelProperties: window.triggerInfo.models['group']}

        if(window.VueApp.container.graphStatus !== 'read_only') {
            this.addWidget("button", "Select Group", null, (v) => {
                window.VueApp.$refs.triggerBuilder.itemPickerType = 'Group';
                window.VueApp.$refs.triggerBuilder.runNodeMethod('triggerGroupPicker', {
                    bucket1: this.properties.groupID & ' - ' & this.properties.value,
                    node: this
                }, true);
            });
        }

    }

    onExecute() {
        this.setOutputData(0, this.properties["value"]);
    }

    getTitle() {
        if (this.flags.collapsed) {
            return this.properties.value;
        }
        return this.title;
    }

    onDrawBackground() {
        //show the current value
        this.outputs[0].label = this.properties["value"];
    }
}

module.exports = Groups
